module.exports = __webpack_public_path__ + "img/03.54a6758e.jpg";